import { useState } from "react"
import { sendHelpRequest } from "../../api"
import { useAction, useAppState } from "../../hooks"
import { ConfirmHelpModal } from "../../modals/ConfirmHelpModal"
import { ECathegory, EHelpType, EInfoMessageType, THelp } from "../../types"
import { GAMES, gameType, getPointsText } from "../../utils"

type HelpProps = {
    help: THelp,
    enabled: boolean,
    refreshUser: any,
    userCathegory?: ECathegory
}

export const Help = ({ help, enabled, refreshUser, userCathegory }: HelpProps) => {
    const [confirmationModalVisible, setConfirmationModalVisible] = useState(false)
    const { setInfoMessageAction } = useAction()
    const { state } = useAppState()

    const getHelpText = () => {
        if (help.help) {
            return help.help
        } else {
            switch (help.type) {
                case EHelpType.NORMAL:
                    if (help.order > 1) {
                        return "Tuto nápovědu využijete, pokud si myslíte, že předchozí část šifry máte vyluštěnou a nevíte, co s dalším krokem."
                    } else {
                        return "Pokud nevíte, co se šifrou, tato nápověda by vás měla popostrčit správným směrem."
                    }
                case EHelpType.INSTRUCTIONS:
                    switch (gameType()) {
                        case GAMES.SIFT:
                            return "Tato nápověda vám stručně popíše postup řešení šifry, dořešit si ji musíte ale sami. Lze ji použít až po klasické nápovědě."
                        case GAMES.ZKRATKA:
                            return "Tato nápověda vám stručně popíše postup řešení šifry, dořešit si ji musíte ale sami. Za vyluštění šifry s touto nápovědou dostanete vždy o 8 bodů méně, bez ohledu na to, jestli jste brali klasické nápovědy."
                        case GAMES.HIDDEN:
                            return ""
                    }
                case EHelpType.ABSOLUTE:
                    switch (gameType()) {
                        case GAMES.SIFT:
                            return "Tato nápověda vám prozradí řešení šifry. Můžete ji využít až poté, co využijete předchozí nápovědy."
                        case GAMES.ZKRATKA:
                            return "Tato nápověda vám prozradí řešení šifry. Při použití této nápovědy nezískáte za šifru žádné body, ale budete moci pokračovat ve hře dál."
                        case GAMES.HIDDEN:
                            return ""
                    }
                case EHelpType.MINI:
                     return "Tato nápověda prozradí řešení minišifry. V případě použití Postupu řešení vzetí této nápovědy stále hraje roli v bodovém zisku, v případě absolutky ne."
                default: return ""
            }
        }
    }

    const getHelpType = () => {
        if (help.name && help.name) { return help.name}
        switch (help.type) {
            case EHelpType.NORMAL:
                return `Nápověda ${help.order}`
            case EHelpType.INSTRUCTIONS:
                return "Postup řešení"
            case EHelpType.ABSOLUTE:
                return "Řešení šifry"
            case EHelpType.MINI:
                return "Řešení minišifry"
            default: return ""
        }
    }

    const helpConfirmed = () => {
        setConfirmationModalVisible(false)
        getHelp()
    }

    const getHelp = () => {
        if (state?.token) {
            sendHelpRequest({ id: help.Id, token: state?.token }).then((res) => {
                console.log(res)
                if (res.sucessMessage) {
                    setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.sucessMessage, timeout: 60 })
                    refreshUser()
                } else if (res.errorMessage) {
                    console.log('ERROR')
                    console.log(res.errorMessage)
                    setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                }
            })
        }
    }


    return (
        <div className='help'>
            <ConfirmHelpModal
                open={confirmationModalVisible}
                handleClose={() => setConfirmationModalVisible(false)}
                help={help}
                approve={helpConfirmed}
                cathegory={userCathegory}
            />
            <div className='help__header'>
                <div className='help__header__type'>{getHelpType()}</div>
                <div className='help__header__penalty'>{getPointsText(help.points, userCathegory, help.type)}</div>
            </div>
            <div className='help__text' dangerouslySetInnerHTML={{ __html: getHelpText() }}/>
            {!help.help
                ?   <div className='help__button'>
                    <button
                        className='button'
                        onClick={() => {
                            setConfirmationModalVisible(true);
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        }}
                        disabled={!enabled}
                    >
                        Vzít nápovědu
                    </button>
                    </div>
                : <></>
            }
        </div>
    )
}